import { render, staticRenderFns } from "./SIKepalaSekolah.vue?vue&type=template&id=1372c52a&"
import script from "./SIKepalaSekolah.vue?vue&type=script&lang=js&"
export * from "./SIKepalaSekolah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports